// Curated RE₿EL design gallery for the 3D Studio.
// Each entry references an SVG in /public/designs/ — loaded on demand
// via fetch + URL.createObjectURL, then handed to the existing
// setDesignImg() decal pipeline in Studio3DClient.
export const REBEL_DESIGNS = [
  {
    id: "not-your-keys",
    file: "/designs/not-your-keys.svg",
    nombre: { es: "Not Your Keys", en: "Not Your Keys", sk: "Not Your Keys", de: "Not Your Keys", "zh-CN": "Not Your Keys" },
    tag:    { es: "CRIPTO CLÁSICO", en: "CRYPTO CLASSIC", sk: "KRIPTO KLASIKA", de: "KRYPTO-KLASSIKER", "zh-CN": "经典加密" },
  },
  {
    id: "21m-club",
    file: "/designs/21m-club.svg",
    nombre: { es: "21M Club", en: "21M Club", sk: "21M Klub", de: "21M Club", "zh-CN": "21M Club" },
    tag:    { es: "EXCLUSIVO", en: "EXCLUSIVE", sk: "EXKLUZÍVNE", de: "EXKLUSIV", "zh-CN": "专属" },
  },
  {
    id: "hodl-or-fold",
    file: "/designs/hodl-or-fold.svg",
    nombre: { es: "HODL or Fold", en: "HODL or Fold", sk: "HODL alebo Fold", de: "HODL or Fold", "zh-CN": "HODL or Fold" },
    tag:    { es: "FILOSOFÍA", en: "PHILOSOPHY", sk: "FILOZOFIA", de: "PHILOSOPHIE", "zh-CN": "哲学" },
  },
  {
    id: "bear-market-survivor",
    file: "/designs/bear-market-survivor.svg",
    nombre: { es: "Bear Survivor", en: "Bear Survivor", sk: "Preživší", de: "Bear Survivor", "zh-CN": "Bear Survivor" },
    tag:    { es: "VETERANO", en: "VETERAN", sk: "VETERÁN", de: "VETERAN", "zh-CN": "老兵" },
  },
  {
    id: "genesis-block",
    file: "/designs/genesis-block.svg",
    nombre: { es: "Genesis Block", en: "Genesis Block", sk: "Genesis Blok", de: "Genesis Block", "zh-CN": "Genesis Block" },
    tag:    { es: "OG · 2009", en: "OG · 2009", sk: "OG · 2009", de: "OG · 2009", "zh-CN": "OG · 2009" },
  },
  {
    id: "in-satoshi-we-trust",
    file: "/designs/in-satoshi-we-trust.svg",
    nombre: { es: "In Satoshi We Trust", en: "In Satoshi We Trust", sk: "In Satoshi We Trust", de: "In Satoshi We Trust", "zh-CN": "In Satoshi We Trust" },
    tag:    { es: "LEYENDA", en: "LEGEND", sk: "LEGENDA", de: "LEGENDE", "zh-CN": "传奇" },
  },
  {
    id: "orange-pill",
    file: "/designs/orange-pill.svg",
    nombre: { es: "Orange Pill", en: "Orange Pill", sk: "Oranžová Pilulka", de: "Orange Pill", "zh-CN": "Orange Pill" },
    tag:    { es: "RABBIT HOLE", en: "RABBIT HOLE", sk: "RABBIT HOLE", de: "RABBIT HOLE", "zh-CN": "兔子洞" },
  },
  {
    id: "candlestick-crown",
    file: "/designs/candlestick-crown.svg",
    nombre: { es: "Candlestick Crown", en: "Candlestick Crown", sk: "Sviečková Koruna", de: "Candlestick Crown", "zh-CN": "Candlestick Crown" },
    tag:    { es: "TRADER KING", en: "TRADER KING", sk: "KRÁĽ TRADER", de: "TRADER KING", "zh-CN": "交易之王" },
  },
  {
    id: "stack-sats",
    file: "/designs/stack-sats.svg",
    nombre: { es: "Stack Sats Daily", en: "Stack Sats Daily", sk: "Stack Sats Denne", de: "Stack Sats Daily", "zh-CN": "Stack Sats Daily" },
    tag:    { es: "DCA LIFE", en: "DCA LIFE", sk: "DCA ŽIVOT", de: "DCA LIFE", "zh-CN": "DCA 生活" },
  },
  {
    id: "decentralized",
    file: "/designs/decentralized.svg",
    nombre: { es: "Decentralized", en: "Decentralized", sk: "Decentralizovaný", de: "Decentralized", "zh-CN": "Decentralized" },
    tag:    { es: "WEB3", en: "WEB3", sk: "WEB3", de: "WEB3", "zh-CN": "WEB3" },
  },
];
